import React from "react";
import { useDispatch, useSelector } from "react-redux";
import DeleteModal from '../../../Components/Common/DeleteModal';
import { createSelector } from "reselect";
import { toggleDeleteAllModal } from "../../../slices/modals/reducer";
import { deleteAllItems } from "../../../slices/folder/thunk";
import { getCampaigns } from "../../../slices/campaigns/thunk";

function DuplicateAllModal() {
  const dispatch = useDispatch();
  // Select Modal State
  const selectModalState = createSelector(state => state.Modal, state => state.deleteAllModal);
  const modalState = useSelector(selectModalState);
  
  async function deleteItems() {
    await dispatch(deleteAllItems());
    // await dispatch(getCampaigns());
    dispatch(toggleDeleteAllModal())
  }
  return (
    <DeleteModal show={modalState}
      onCloseClick={() => dispatch(toggleDeleteAllModal())}
      onDeleteClick={deleteItems} />
  )
};

export default DuplicateAllModal;